import layout from '@/layout'

export default {
  path: '/winner',
  component: layout,
  redirect: '/winner/daily',
  name: 'winner_daily',
  meta: {
    title: 'winner',
    icon: 'winner'
  },
  children: [
    {
      path: '/winner/daily',
      name: 'winner_daily',
      component: () => import('@/views/winner/pages/winner_daily/index.vue'),
      meta: {
        title: 'winner_daily',
        icon: 'bang'
      }
    }
  ]
}
